var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"id":"header"}},[_c('top-bar'),_vm._v(" "),_c('inner-header'),_vm._v(" "),_c('nav-bar',{attrs:{"data":_vm.menu_items}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }